export type MediaTab = 'Photos' | '3D Walkthrough' | 'Video Tour' | 'Floor Plans';
export const MEDIA_TABS: MediaTab[] = ['Photos', '3D Walkthrough', 'Video Tour', 'Floor Plans'];
